import { useQueryParams } from "@/shared/hooks";
import { useParams } from "react-router";

export const useControlResultsParams = () => {
  const { getQueryParam } = useQueryParams();
  const { controlId } = useParams();

  const controlResultIdParam = getQueryParam("r");
  const activeControlResultId = controlResultIdParam
    ? controlResultIdParam
    : null;
  const commentId = getQueryParam("cmnt");
  const activeCommentId = commentId ? commentId : null;

  return {
    activeControlResultId,
    activeCommentId,
    controlId: controlId,
  };
};
